import axios from 'axios'

const url = 'https://fiemsapi.elkanisgroup.com/api/v2'

class LoginService {
  static login (data) {
    return axios.post(`${url}/admin/login`, data)
  }
}

export default LoginService
